const releasesFR = {
    "view": {
        "table": {
            "title": "Votre liste de sorties",
            "column": {
                "name": "Nom",
                "artist": "Artiste",
                "catalogue_number": "Numéro de cat.",
                "release_date": "Date de sortie",
                "status": "Statut",
                "store_urls": "URLs des magasins",
                "qc": "QC",
                "pre_scan": "Pré-Scan",
                "alert": "Alerte",
                "flagged": "Signalé",
                "action": "Action"
            },
            "label": {
                "status_ready": "Prêt",
                "status_approval": "Soumission en file d'attente",
                "status_takedown_request": "Demande de retrait",
                "status_taken_down": "Retiré",
                "status_distributed": "Distribué",
                "status_locked": "En cours - Verrouillé",
                "status_delivering": "En cours de livraison",
                "status_unlocked": "Veuillez modifier",
                "status_offline": "Hors ligne",
                "status_re_delivery-delivery": "Ré-livraison",
                "status_re_delivery-editing": "Édition de ré-livraison",
                "status_unknown": "Statut inconnu"
            },
            "button": {
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "dropdown": {
                "item": {
                    "action": "Action",
                    "distribute": "Distribuer",
                    "viewRelease": "Voir la sortie",
                    "editReleaseMetadata": "Modifier les métadonnées de la sortie",
                    "editTracks": "Modifier les pistes",
                    "takedown": "Retirer",
                    "submitEditing": "Soumettre l'édition",
                    "deliveredList": "Liste livrée",
                    "copyEanUpc": "Copier EAN/UPC"
                },
                "message": {
                    "submitInformationTooltip": "Vous n'avez pas encore fourni toutes vos informations, vous ne pouvez donc pas distribuer les sorties. Pour ce faire, veuillez soumettre vos informations.",
                    "submitMetadataTooltip": "Veuillez soumettre les métadonnées de toutes les pistes pour distribuer la sortie.",
                    "submitEditingMetadataTooltip": "Veuillez soumettre les métadonnées de toutes les pistes pour soumettre les modifications.",
                    "submitEditingTokenRequiredTooltip": "Au moins 1 token est requis pour soumettre la modification pour la ré-livraison. <2>Commander des tokens</2>.",
                    "blacklistedArtistTooltip": "Cette sortie ne peut pas être distribuée car elle contient une ou plusieurs pistes d'un artiste blacklisté. Veuillez contacter notre équipe de support pour plus d'informations.",
                    "distributionDisabledPreScanInProgress": "Veuillez attendre que le pré-scan soit terminé avant de distribuer la sortie.",
                    "distributionDisabledPreScanNotDone": "Veuillez effectuer le pré-scan avant de distribuer la sortie.",
                    "distributionDisabledPreScanDeclarationNotSubmitted": "Veuillez soumettre la déclaration du pré-scan avant de distribuer la sortie.",
                },
                "modal": {
                    "editMetadata": {
                        "header": "Êtes-vous vraiment sûr de vouloir modifier les métadonnées ?",
                        "description": {
                            "point1": "<strong>Cela modifiera vos métadonnées et peut affecter la sortie.</strong>",
                            "point2": "Procédez uniquement si vous êtes complètement sûr.",
                            "point3": "<strong>VEUILLEZ NE PAS</strong> modifier les métadonnées juste pour tester et explorer."
                        },
                        "button": {
                            "cancel": "Annuler",
                            "confirm": "Je comprends"
                        }
                    },
                    "distribute": {
                        "header": "Êtes-vous sûr que toutes les informations saisies sont valides et représentent pleinement cette sortie ?",
                        "description": {
                            "point1": "Après cette action, votre sortie sera vérifiée et si les informations sont correctes, elle sera distribuée aux dates de distribution officielles et exclusives.",
                            "point2": "En confirmant et en acceptant ce formulaire, vous acceptez pleinement et vous conformez aux <1>Conditions de distribution</1>, <3>Conditions d'utilisation</3> et <5>Politique de confidentialité</5>.",
                            "point3": "En confirmant et en acceptant ce formulaire, vous confirmez sans équivoque que le contenu soumis avec les actifs, les fichiers audio et les métadonnées vous appartient exclusivement ou est entièrement licencié à votre label.",
                            "point4": "Par la présente, vous acceptez pleinement d'être seul responsable de toute information trompeuse, utilisation non autorisée, activité illégale ou tout type de litige.",
                            "flaggedTracksTerms": {
                                "header": "Conditions des pistes signalées",
                                "point1": "Veuillez noter : <strong>'{{releaseName}}'</strong> contient une ou plusieurs pistes signalées, des frais de <strong>15 €</strong> par piste signalée s'appliquent pour livrer la sortie à <strong>Spotify</strong>. Comme vous avez choisi de ne pas payer ces frais pour le moment, la sortie ne sera pas livrée à Spotify. En confirmant et en acceptant ce formulaire, vous reconnaissez et acceptez ces conditions.",
                                "point2": "À l'avenir, si vous choisissez que la sortie soit livrée à <strong>Spotify</strong>, vous pouvez vous rendre dans la section Signalée du tableau des sorties et suivre les instructions de paiement."
                            },
                            "artificialStreamingDeclaration": {
                                "header": "Déclaration de streaming artificiel",
                                "point1": "<strong>1.</strong> Je comprends et j'accepte pleinement de ne pas m'engager dans une forme quelconque de streaming artificiel, y compris l'utilisation de bots, de fermes de streaming ou de toute méthode qui manipule les métriques des DSP.",
                                "point2": "<strong>2.</strong> Je ne paierai pas et n'offrirai pas de paiement pour des placements dans des playlists, et je ne travaillerai pas avec un tiers promettant des placements garantis — je comprends que cela est considéré comme une fraude et une arnaque.",
                                "point3": "<strong>3.</strong> Je reconnais que de telles actions peuvent entraîner une résiliation immédiate, la confiscation des redevances, des réclamations légales, des pénalités contractuelles et des frais, ainsi que des rapports aux DSP et aux autorités.",
                                "point4": "<strong>4.</strong> Je garantis également d'informer et d'éduquer tous les artistes ou clients avec lesquels je travaille sur ces règles et de m'assurer qu'ils s'y conforment.",
                                "point5": "<strong>5.</strong> Je comprends que si je m'engage dans un streaming artificiel, mes données KYC, y compris mon nom complet, mon adresse, ma carte d'identité et d'autres informations personnelles, peuvent être partagées avec les départements juridiques des DSP, tels que ceux de Spotify, Apple Music et d'autres.",
                                "point6": "<strong>6.</strong> J'accepte l'entière responsabilité légale de toute violation.",
                                "acknowledgment": "Je reconnais par la présente et accepte de respecter les termes ci-dessus concernant le streaming artificiel, et j'accepte l'entière responsabilité légale de toute violation."
                            }
                        },
                        "button": {
                            "cancel": "Annuler",
                            "confirm": "Confirmer et accepter"
                        }
                    },
                    "takedown": {
                        "header": "Êtes-vous sûr de vouloir retirer cette sortie de tous les magasins ?",
                        "description": {
                            "point1": "Cette action est irréversible.",
                            "point2": "En retirant cette sortie, vous vous conformez aux <1>Conditions de distribution</1>, <3>Conditions d'utilisation</3> et <5>Politique de confidentialité</5>."
                        },
                        "button": {
                            "cancel": "Annuler",
                            "confirm": "Confirmer et accepter"
                        }
                    },
                    "finishEditing": {
                        "header": "Êtes-vous sûr que toutes les informations saisies sont valides et représentent pleinement cette sortie ?",
                        "description": {
                            "point1": "Après cette action, votre sortie sera vérifiée et si les informations sont correctes, elle sera redistribuée aux partenaires DSP. <strong>NOTE, seules les MÉTADONNÉES seront envoyées aux DSP, le contenu tel que les IMAGES et les fichiers AUDIO ne peut pas être mis à jour de cette manière.</strong>",
                            "point2": "En confirmant et en acceptant ce formulaire, vous acceptez pleinement et vous conformez aux <1>Conditions d'utilisation</1> et aux termes de notre accord de distribution exclusif.",
                            "point3": "En confirmant et en acceptant ce formulaire, vous acceptez pleinement et vous conformez à la <1>Politique de confidentialité</1>.",
                            "point4": "En confirmant et en acceptant ce formulaire, vous confirmez sans équivoque que le contenu soumis avec les actifs, les fichiers audio et les métadonnées vous appartient exclusivement ou est entièrement licencié à votre label.",
                            "point5": "Par la présente, vous acceptez pleinement d'être seul responsable de toute information trompeuse, utilisation non autorisée, activité illégale ou tout type de litige."
                        },
                        "button": {
                            "cancel": "Annuler",
                            "confirm": "Confirmer et accepter"
                        }
                    }
                }
            },
            "message": {
                "success": "Sortie mise à jour !",
                "declaration_success": "Déclaration soumise pour examen par l'administrateur.",
                "declaration_error": "Une erreur s'est produite lors de la soumission de la déclaration, veuillez réessayer plus tard.",
                "pre_scan_declaration_success": "Déclaration du pré-scan soumise avec succès.",
                "pre_scan_declaration_error": "Une erreur s'est produite lors de la soumission de la déclaration du pré-scan, veuillez réessayer plus tard.",
                "pre_scan_success": "Sortie soumise avec succès pour le scan.",
                "pre_scan_error": "Une erreur s'est produite lors du scan de la sortie, veuillez réessayer plus tard.",
                "linkCopied": "Lien copié dans le presse-papiers !"
            }
        },
        "message": {
            "trackDistributionAllowanceSpent": "Vous avez dépensé votre allocation de distribution de pistes. Pour télécharger plus de pistes, veuillez mettre à niveau votre compte ou contacter notre équipe de support.",
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations.",
            "subscriptionUpgradeReleaseTransfer": "Votre plan d'abonnement actuel ne prend pas en charge la fonctionnalité de transfert de sortie. Si vous transférez un catalogue plus important ou souhaitez transférer plus de catalogues de labels vers Music Link en quelques clics, veuillez <1>mettre à niveau</1> votre plan d'abonnement.",
            "noAccessReleaseTransfer": "Actuellement, vous n'avez pas la permission d'utiliser la fonctionnalité de transfert de sortie. Si vous transférez un catalogue plus important ou souhaitez transférer plus de catalogues de labels vers Music Link en quelques clics, n'hésitez pas à contacter notre équipe de support.",
            "accountBlacklisted": "Votre compte a été blacklisté après examen car nous avons constaté que les informations associées à votre compte sont liées à un utilisateur internationalement blacklisté dans notre système. Consequently, we have disabled the Distribution feature for your account.",
        }
    },
    "add": {
        "title": "Ajouter une nouvelle sortie",
        "form": {
            "label": {
                "required": "Requis",
                "name": "Nom de la sortie",
                "version": "Version de la sortie",
                "subuser": "Sous-utilisateur",
                "label": "Label",
                "copyright": "Droits d'auteur ©",
                "copyright_year": "Année des droits d'auteur ©",
                "copyright_publisher": "Droits d'auteur ℗",
                "copyright_publisher_year": "Année des droits d'auteur ℗",
                "genre": "Genre",
                "subgenre": "Sous-genre",
                "catalog_number": "Numéro de catalogue",
                "artwork": "Illustration",
                "artwork_alt": "Votre illustration",
                "new_release": "Est-ce une nouvelle sortie ?",
                "original_release_date": "Date de sortie originale",
                "official_release_date": "Date de sortie officielle",
                "backcatalog": "Catalogue précédent",
                "assisted_dates": "Dates assistées",
                "exclusive_store_release_date": "Date de sortie exclusive en magasin",
                "additional_metadata": "Métadonnées supplémentaires",
                "release_description": "Description de la sortie",
                "release_language": "Langue du nom de la sortie",
                "auto_detect_language": "Détection automatique (Langue)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Génération automatique (ean)",
                "territories": "Territoires",
                "countries": "Pays",
                "youtube_declaration_header": "DÉCLARATION D'ID DE CONTENU YOUTUBE",
                "youtube_declaration_intro": "Pour opter pour l'ID de contenu YouTube pour cette sortie, vous devez vous assurer de remplir TOUTES les conditions suivantes :",
                "youtube_declaration_certify": "Je, <strong>{{firstName}} {{lastName}}</strong>, sous peine de parjure, certifie par la présente que les informations ci-dessus sont vraies et correctes.",
                "youtube_declaration_point1": "J'ai suffisamment de droits sur le matériel.",
                "youtube_declaration_point2": "Tout le contenu de référence est suffisamment distinctif.",
                "youtube_declaration_point3": "J'ai des références individuelles pour chaque œuvre de propriété intellectuelle.",
                "youtube_declaration_point4": "Le contenu livré n'est <strong>pas</strong> l'un des suivants : domaine public, contenu sous licence non exclusive, extraits d'autres sources utilisés sous les principes de l'utilisation équitable, séquences de jeu vidéo (par un autre que l'éditeur du jeu), enregistrements de karaoké, remasterisation sans autorisation, enregistrements similaires, contenu doublé, accélération/ralentissement, effets sonores, fonds sonores, mixes DJ continus, mashups, listes à rebours ou tout autre contenu interdit ou inéligible nommé dans les directives de l'ID de contenu YouTube ci-dessous.",
                "youtube_declaration_account": "Je comprends que mon compte peut être désactivé et résilié en cas de violations. De plus, je comprends pleinement que je peux être tenu responsable de tous frais, dommages, frais juridiques ou autres dépenses qui pourraient s'accumuler.",
                "youtube_declaration_guidelines": "Conformément aux <1><strong>Directives de l'ID de contenu YouTube</strong></1>, le contenu soumis par le biais de cette sortie est entièrement éligible pour l'ID de contenu YouTube.",
                "youtube_content_id_eligible": "Je confirme que mon contenu est éligible pour <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "Mon contenu n'est pas éligible pour <strong>Youtube Content ID</strong>",
                "immersive_audio": "Cette sortie a de l'audio immersif"
            },
            "placeholder": {
                "version": "Laisser vide si vous n'êtes pas sûr ou si c'est une sortie régulière",
                "select_date": "Sélectionner une date...",
                "copyright": "Habituellement le nom de votre label",
                "copyright_publisher": "Habituellement le nom de votre label",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Insérez votre numéro de catalogue. Habituellement, les labels insèrent l'abréviation du nom du label et un numéro. Par exemple {{prefix}}001, {{prefix}}002...",
                "label": "Sélectionner un label...",
                "subuser": "Sélectionner un sous-utilisateur...",
                "genre": "Sélectionner un genre...",
                "subgenre": "Sélectionner un sous-genre...",
                "ean": "Laisser vide si vous n'êtes pas sûr !",
                "release_description": "Quelques mots sur votre sortie. Pas de liens ni d'adresses e-mail, s'il vous plaît. 600 caractères max"
            },
            "help_text": {
                "name": "Veuillez ne pas utiliser d'ajouts au nom de la sortie tels que LP et EP.",
                "version": "Certaines sorties sont publiées en plus d'une version, si c'est le cas, veuillez entrer le nom de la version. Si votre sortie est originale/standard, veuillez ignorer ce champ.",
                "subuser": "Remarque : utilisez uniquement ce menu déroulant si vous souhaitez ajouter une sortie pour l'un de vos sous-utilisateurs, sinon laissez-le non sélectionné.",
                "label": "Remarque : veuillez sélectionner votre label dans le menu déroulant s'il existe déjà dans le système, sinon créez votre label en cliquant <1>ici</1>, une fois créé, vous pourrez le sélectionner dans le menu déroulant.",
                "catalog_number": "Insérez votre numéro de catalogue. Habituellement, les labels insèrent l'abréviation du nom du label et un numéro. Par exemple {{prefix}}001, {{prefix}}002...",
                "artwork": "Téléchargez des formats JPG, résolution uniquement 3000x3000 px, @ 72 dpi",
                "original_release_date": "Date de sortie originale pour tous les magasins dans le monde.",
                "official_release_date": "Date de sortie officielle pour tous les magasins dans le monde.",
                "release_language": "Dans quelle langue le nom de la sortie est-il écrit ? Veuillez vérifier à nouveau si vous n'êtes pas sûr. Si cette saisie est incorrecte, certains magasins comme iTunes et Apple Music rejetteront la sortie.",
                "ean": "Le code universel des produits ou le numéro d'article européen pour la sortie. Les codes valides sont de 13 chiffres. Si vous n'avez pas le vôtre, nous en générerons un pour vous."
            },
            "option": {
                "yes": "Oui",
                "no": "Non",
                "no_exclusive": "Pas d'exclusivité",
                "beatport_2weeks": "Beatport 2 semaines",
                "beatport_4weeks": "Beatport 4 semaines",
                "preorder_1week": "Pré-commande 1 semaine",
                "preorder_2weeks": "Pré-commande 2 semaines",
                "traxsource_2weeks": "Traxsource 2 semaines",
                "select": "Sélectionner...",
                "worldwide": "Mondial",
                "only_selected": "Seulement les pays sélectionnés",
                "all_except_selected": "Tous sauf les pays sélectionnés"
            },
            "message": {
                "track_name_required": "Veuillez taper le nom de la piste",
                "mix_name_required": "Veuillez taper le nom du mix",
                "mix_name_invalid": "Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores",
                "artist_required": "Veuillez sélectionner un artiste",
                "artist_type_required": "Veuillez sélectionner le type d'artiste",
                "catalog_duplicate": "Le numéro de catalogue '{{number}}' a été utilisé. Veuillez en insérer un autre.",
                "ean_duplicate": "Ce numéro EAN est associé à une autre sortie. Veuillez en insérer un autre.",
                "artist_added": "Nouvel artiste ajouté !",
                "track_limit": "Votre limite actuelle de pistes est insuffisante. Veuillez mettre à niveau votre compte ou contacter le support.",
                "select_day": "Veuillez sélectionner un jour.",
                "form_error": "Le formulaire ne peut pas être soumis ! Veuillez remplir tous les champs et vérifier les erreurs !",
                "ean_invalid": "La valeur n'est pas un EAN valide. Si vous insérez une nouvelle sortie, laissez ce champ vide et nous générerons un EAN pour vous. Si vous téléchargez un catalogue précédent et que l'EAN n'est pas valide, veuillez nous contacter.",
                "ean_length": "Le numéro EAN doit être égal à 13 caractères",
                "artwork_invalid": "Ce fichier est invalide, veuillez vous assurer que l'image a une extension .jpg, des couleurs RGB, des dimensions de 3000 X 3000 et jusqu'à 4 Mo.",
                "track_invalid": "Ce fichier est invalide, veuillez vous assurer de bien encoder votre fichier en 16 bits, 44,1 Khz.",
                "artworkSwapTokenRequiredTooltip": "Votre solde actuel de tokens est insuffisant. Au moins 1 token est requis pour remplacer la pochette."
            },
            "button": {
                "reset": "Réinitialiser",
                "save_only": "Enregistrer seulement",
                "save_and_continue": "Enregistrer et continuer"
            },
            "modal": {
                "assisted_days": {
                    "header": "Êtes-vous sûr de vouloir ignorer les meilleures pratiques de date de sortie ?",
                    "body": "Veuillez noter qu'en sélectionnant cette option, votre date de sortie pourrait ne pas être acceptée par les magasins ou ingérée et publiée à la date sélectionnée. De plus, vous réduisez fortement les opportunités de marketing.",
                    "button": {
                        "cancel": "Annuler",
                        "confirm": "Confirmer"
                    }
                },
                "release_created": {
                    "header": "Sortie créée !",
                    "body": "Votre sortie a été créée avec succès !",
                    "button": {
                        "close": "Fermer"
                    }
                }
            }
        }
    },
    "update": {
        "title": "Mettre à jour la sortie",
        "form": {
            "label": {
                "required": "Requis",
                "name": "Nom de la sortie",
                "version": "Version de la sortie",
                "subuser": "Sous-utilisateur",
                "label": "Label",
                "copyright": "Droits d'auteur ©",
                "copyright_year": "Année des droits d'auteur ©",
                "copyright_publisher": "Droits d'auteur ℗",
                "copyright_publisher_year": "Année des droits d'auteur ℗",
                "genre": "Genre",
                "subgenre": "Sous-genre",
                "catalog_number": "Numéro de catalogue",
                "artwork": "Illustration",
                "artwork_alt": "Votre illustration",
                "new_release": "Est-ce une nouvelle sortie ?",
                "original_release_date": "Date de sortie originale",
                "official_release_date": "Date de sortie officielle",
                "backcatalog": "Catalogue précédent",
                "assisted_dates": "Dates assistées",
                "exclusive_store_release_date": "Date de sortie exclusive en magasin",
                "additional_metadata": "Métadonnées supplémentaires",
                "release_description": "Description de la sortie",
                "release_language": "Langue du nom de la sortie",
                "auto_detect_language": "Détection automatique (Langue)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Génération automatique (ean)",
                "territories": "Territoires",
                "countries": "Pays",
                "youtube_declaration_header": "DÉCLARATION D'ID DE CONTENU YOUTUBE",
                "youtube_declaration_intro": "Pour opter pour l'ID de contenu YouTube pour cette sortie, vous devez vous assurer de remplir TOUTES les conditions suivantes :",
                "youtube_declaration_certify": "Je, <strong>{{firstName}} {{lastName}}</strong>, sous peine de parjure, certifie par la présente que les informations ci-dessus sont vraies et correctes.",
                "youtube_declaration_point1": "J'ai suffisamment de droits sur le matériel.",
                "youtube_declaration_point2": "Tout le contenu de référence est suffisamment distinctif.",
                "youtube_declaration_point3": "J'ai des références individuelles pour chaque œuvre de propriété intellectuelle.",
                "youtube_declaration_point4": "Le contenu livré n'est <strong>pas</strong> l'un des suivants : domaine public, contenu sous licence non exclusive, extraits d'autres sources utilisés sous les principes de l'utilisation équitable, séquences de jeu vidéo (par un autre que l'éditeur du jeu), enregistrements de karaoké, remasterisation sans autorisation, enregistrements similaires, contenu doublé, accélération/ralentissement, effets sonores, fonds sonores, mixes DJ continus, mashups, listes à rebours ou tout autre contenu interdit ou inéligible nommé dans les directives de l'ID de contenu YouTube ci-dessous.",
                "youtube_declaration_account": "Je comprends que mon compte peut être désactivé et résilié en cas de violations. De plus, je comprends pleinement que je peux être tenu responsable de tous frais, dommages, frais juridiques ou autres dépenses qui pourraient s'accumuler.",
                "youtube_declaration_guidelines": "Conformément aux <1><strong>Directives de l'ID de contenu YouTube</strong></1>, le contenu soumis par le biais de cette sortie est entièrement éligible pour l'ID de contenu YouTube.",
                "youtube_content_id_eligible": "Je confirme que mon contenu est éligible pour <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "Mon contenu n'est pas éligible pour <strong>Youtube Content ID</strong>",
                "immersive_audio": "Cette sortie a de l'audio immersif"
            },
            "placeholder": {
                "version": "Laisser vide si vous n'êtes pas sûr ou si c'est une sortie régulière",
                "select_date": "Sélectionner une date...",
                "copyright": "Habituellement le nom de votre label",
                "copyright_publisher": "Habituellement le nom de votre label",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Insérez votre numéro de catalogue. Habituellement, les labels insèrent l'abréviation du nom du label et un numéro. Par exemple {{prefix}}001, {{prefix}}002...",
                "label": "Sélectionner un label...",
                "subuser": "Sélectionner un sous-utilisateur...",
                "genre": "Sélectionner un genre...",
                "subgenre": "Sélectionner un sous-genre...",
                "ean": "Laisser vide si vous n'êtes pas sûr !",
                "release_description": "Quelques mots sur votre sortie. Pas de liens ni d'adresses e-mail, s'il vous plaît. 600 caractères max"
            },
            "help_text": {
                "name": "Veuillez ne pas utiliser d'ajouts au nom de la sortie tels que LP et EP.",
                "version": "Certaines sorties sont publiées en plus d'une version, si c'est le cas, veuillez entrer le nom de la version. Si votre sortie est originale/standard, veuillez ignorer ce champ.",
                "subuser": "Remarque : utilisez uniquement ce menu déroulant si vous souhaitez ajouter une sortie pour l'un de vos sous-utilisateurs, sinon laissez-le non sélectionné.",
                "label": "Remarque : veuillez sélectionner votre label dans le menu déroulant s'il existe déjà dans le système, sinon créez votre label en cliquant <1>ici</1>, une fois créé, vous pourrez le sélectionner dans le menu déroulant.",
                "catalog_number": "Insérez votre numéro de catalogue. Habituellement, les labels insèrent l'abréviation du nom du label et un numéro. Par exemple {{prefix}}001, {{prefix}}002...",
                "artwork": "Téléchargez des formats JPG, résolution uniquement 3000x3000 px, @ 72 dpi",
                "original_release_date": "Date de sortie originale pour tous les magasins dans le monde.",
                "official_release_date": "Date de sortie officielle pour tous les magasins dans le monde.",
                "release_language": "Dans quelle langue le nom de la sortie est-il écrit ? Veuillez vérifier à nouveau si vous n'êtes pas sûr. Si cette saisie est incorrecte, certains magasins comme iTunes et Apple Music rejetteront la sortie.",
                "ean": "Le code universel des produits ou le numéro d'article européen pour la sortie. Les codes valides sont de 13 chiffres. Si vous n'avez pas le vôtre, nous en générerons un pour vous."
            },
            "option": {
                "yes": "Oui",
                "no": "Non",
                "no_exclusive": "Pas d'exclusivité",
                "beatport_2weeks": "Beatport 2 semaines",
                "beatport_4weeks": "Beatport 4 semaines",
                "preorder_1week": "Pré-commande 1 semaine",
                "preorder_2weeks": "Pré-commande 2 semaines",
                "traxsource_2weeks": "Traxsource 2 semaines",
                "select": "Sélectionner...",
                "worldwide": "Mondial",
                "only_selected": "Seulement les pays sélectionnés",
                "all_except_selected": "Tous sauf les pays sélectionnés"
            },
            "message": {
                "track_name_required": "Veuillez taper le nom de la piste",
                "mix_name_required": "Veuillez taper le nom du mix",
                "mix_name_invalid": "Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores",
                "artist_required": "Veuillez sélectionner un artiste",
                "artist_type_required": "Veuillez sélectionner le type d'artiste",
                "catalog_duplicate": "Le numéro de catalogue '{{number}}' a été utilisé. Veuillez en insérer un autre.",
                "ean_duplicate": "Ce numéro EAN est associé à une autre sortie. Veuillez en insérer un autre.",
                "artist_added": "Nouvel artiste ajouté !",
                "track_limit": "Votre limite actuelle de pistes est de {{trackLimit}} piste(s). Pour télécharger plus de pistes, veuillez mettre à niveau votre compte ou contacter notre équipe de support.",
                "select_day": "Veuillez sélectionner un jour.",
                "form_error": "Le formulaire ne peut pas être soumis ! Veuillez remplir tous les champs et vérifier les erreurs !",
                "ean_invalid": "La valeur n'est pas un EAN valide. Si vous insérez une nouvelle sortie, laissez ce champ vide et nous générerons un EAN pour vous. Si vous téléchargez un catalogue précédent et que l'EAN n'est pas valide, veuillez nous contacter.",
                "ean_length": "Le numéro EAN doit être égal à 13 caractères",
                "artwork_invalid": "Ce fichier est invalide, veuillez vous assurer que l'image a une extension .jpg, des couleurs RGB, des dimensions de 3000 X 3000 et jusqu'à 4 Mo.",
                "track_invalid": "Ce fichier est invalide, veuillez vous assurer de bien encoder votre fichier en 16 bits, 44,1 Khz."
            },
            "button": {
                "reset": "Réinitialiser",
                "submit_form": "Soumettre le formulaire",
                "save_and_continue": "Enregistrer et continuer"
            },
            "modal": {
                "assisted_days": {
                    "header": "Êtes-vous sûr de vouloir ignorer les meilleures pratiques de date de sortie ?",
                    "body": "Veuillez noter qu'en sélectionnant cette option, votre date de sortie pourrait ne pas être acceptée par les magasins ou ingérée et publiée à la date sélectionnée. De plus, vous réduisez fortement les opportunités de marketing.",
                    "button": {
                        "cancel": "Annuler",
                        "confirm": "Confirmer"
                    }
                },
                "release_updated": {
                    "header": "Sortie mise à jour !",
                    "body": "Votre sortie a été mise à jour avec succès !",
                    "button": {
                        "close": "Fermer"
                    }
                }
            }
        }
    },
    "transfer": {
        "title": "Transférer la sortie",
        "view": {
            "title": "Transférer la sortie",
            "label": {
                "searchBy": "Rechercher par",
                "upc": "Numéro UPC",
                "url": "URL de la sortie en magasin",
                "name": "Nom de la sortie",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "fetchReleaseDetails": "Récupération des détails de la sortie..."
            },
            "placeholder": {
                "upc": "Entrez le numéro UPC/EAN de la sortie, par exemple 5055964352523",
                "url": "Entrez l'URL de la sortie en magasin, par exemple open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ou www.deezer.com/en/album/413370367",
                "name": "Entrez le nom de la sortie, par exemple Warrior"
            },
            "help_text": {
                "upc": "Remarque : utilisez uniquement ce menu déroulant si vous souhaitez ajouter une sortie déjà sur Spotify ou Deezer.",
                "url": "Remarque : utilisez uniquement ce menu déroulant si vous souhaitez ajouter une sortie déjà sur Spotify ou Deezer.",
                "name_spotify": "Remarque : utilisez uniquement ce menu déroulant si vous souhaitez ajouter une sortie déjà sur Spotify.",
                "name_deezer": "Remarque : utilisez uniquement ce menu déroulant si vous souhaitez ajouter une sortie déjà sur Deezer."
            },
            "button": {
                "reset": "Réinitialiser",
                "transfer": "Transférer"
            },
            "message": {
                "release_exists": "Une sortie avec ce numéro UPC appartient déjà à un autre utilisateur au sein de la plateforme Music Link. Veuillez importer uniquement les sorties qui appartiennent entièrement à votre entreprise et à votre label. Si vous pensez que quelqu'un a pris votre sortie sans permission, veuillez contacter notre équipe de support."
            }
        },
        "modal": {
            "header": "Conditions de transfert de sortie",
            "ownership_warranty": {
                "header": "Garantie de propriété",
                "body": {
                    "point1": "En acceptant ces conditions, vous reconnaissez et garantissez que vous avez la propriété légale ou représentez le propriétaire légitime de tout le contenu, y compris la sortie et les chansons associées, fournis ici.",
                    "point2": "Vous affirmez qu'aucun matériel protégé par des droits d'auteur ou propriété intellectuelle appartenant à un tiers n'est incorporé dans cette sortie."
                }
            },
            "non_infringement_warranty": {
                "header": "Garantie de non-violation",
                "body": {
                    "point1": "En procédant, vous confirmez expressément que le contenu soumis dans cette sortie ne porte atteinte à aucun droit de tiers, y compris mais sans s'y limiter, les droits d'auteur, les marques commerciales ou tout autre droit de propriété.",
                    "point2": "Vous acceptez de ne pas inclure de matériel provenant de sources externes sans autorisation appropriée."
                }
            },
            "exclusivity_declaration": {
                "header": "Déclaration d'exclusivité",
                "body": {
                    "point1": "En consentant à ces conditions, vous vous engagez à ce que le contenu présenté dans cette sortie soit exclusif à votre propriété ou représentation autorisée, et qu'il n'a pas été offert ou publié à une autre entité ou plateforme.",
                    "point2": "Vous assumez l'entière responsabilité de toute violation de l'exclusivité et comprenez que toute violation de ce type peut entraîner des conséquences juridiques."
                }
            },
            "legal_consequences_awareness": {
                "header": "Connaissance des conséquences juridiques",
                "body": {
                    "point1": "Il est crucial de comprendre que toute violation des termes et garanties énoncés dans ce modal ou ces conditions peut entraîner de graves répercussions juridiques.",
                    "point2": "Ces pénalités pourraient inclure, mais ne sont pas limitées à, des responsabilités financières substantielles, des injonctions légales et des dommages à la réputation.",
                    "point3": "En acceptant ces conditions, vous reconnaissez la gravité de respecter les obligations énoncées et reconnaissez que le non-respect peut entraîner des actions légales contre vous ou votre organisation."
                }
            },
            "button": {
                "cancel": "Annuler",
                "agree": "J'accepte"
            }
        },
        "form": {
            "title": "Transférer la sortie",
            "label": {
                "required": "Requis",
                "name": "Nom de la sortie",
                "version": "Version de la sortie",
                "subuser": "Sous-utilisateur",
                "label": "Label",
                "copyright": "Droits d'auteur ©",
                "copyright_year": "Année des droits d'auteur ©",
                "copyright_publisher": "Droits d'auteur ℗",
                "copyright_publisher_year": "Année des droits d'auteur ℗",
                "genre": "Genre",
                "subgenre": "Sous-genre",
                "catalog_number": "Numéro de catalogue",
                "artwork": "Illustration",
                "artwork_alt": "Votre illustration",
                "new_release": "Est-ce une nouvelle sortie ?",
                "original_release_date": "Date de sortie originale",
                "official_release_date": "Date de sortie officielle",
                "backcatalog": "Catalogue précédent",
                "assisted_dates": "Dates assistées",
                "exclusive_store_release_date": "Date de sortie exclusive en magasin",
                "additional_metadata": "Métadonnées supplémentaires",
                "release_description": "Description de la sortie",
                "release_language": "Langue du nom de la sortie",
                "auto_detect_language": "Détection automatique (Langue)",
                "ean": "EAN / UPC",
                "territories": "Territoires",
                "countries": "Pays",
                "youtube_declaration_header": "DÉCLARATION D'ID DE CONTENU YOUTUBE",
                "youtube_declaration_intro": "Pour opter pour l'ID de contenu YouTube pour cette sortie, vous devez vous assurer de remplir TOUTES les conditions suivantes :",
                "youtube_declaration_certify": "Je, <strong>{{firstName}} {{lastName}}</strong>, sous peine de parjure, certifie par la présente que les informations ci-dessus sont vraies et correctes.",
                "youtube_declaration_point1": "J'ai suffisamment de droits sur le matériel.",
                "youtube_declaration_point2": "Tout le contenu de référence est suffisamment distinctif.",
                "youtube_declaration_point3": "J'ai des références individuelles pour chaque œuvre de propriété intellectuelle.",
                "youtube_declaration_point4": "Le contenu livré n'est <strong>pas</strong> l'un des suivants : domaine public, contenu sous licence non exclusive, extraits d'autres sources utilisés sous les principes de l'utilisation équitable, séquences de jeu vidéo (par un autre que l'éditeur du jeu), enregistrements de karaoké, remasterisation sans autorisation, enregistrements similaires, contenu doublé, accélération/ralentissement, effets sonores, fonds sonores, mixes DJ continus, mashups, listes à rebours ou tout autre contenu interdit ou inéligible nommé dans les directives de l'ID de contenu YouTube ci-dessous.",
                "youtube_declaration_account": "Je comprends que mon compte peut être désactivé et résilié en cas de violations. De plus, je comprends pleinement que je peux être tenu responsable de tous frais, dommages, frais juridiques ou autres dépenses qui pourraient s'accumuler.",
                "youtube_declaration_guidelines": "Conformément aux <1><strong>Directives de l'ID de contenu YouTube</strong></1>, le contenu soumis par le biais de cette sortie est entièrement éligible pour l'ID de contenu YouTube.",
                "youtube_content_id_eligible": "Je confirme que mon contenu est éligible pour <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "Mon contenu n'est pas éligible pour <strong>Youtube Content ID</strong>",
                "immersive_audio": "Cette sortie a de l'audio immersif"
            },
            "placeholder": {
                "version": "Laisser vide si vous n'êtes pas sûr ou si c'est une sortie régulière",
                "select_date": "Sélectionner une date...",
                "copyright": "Habituellement le nom de votre label",
                "copyright_publisher": "Habituellement le nom de votre label",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Insérez votre numéro de catalogue. Habituellement, les labels insèrent l'abréviation du nom du label et un numéro. Par exemple {{prefix}}001, {{prefix}}002...",
                "label": "Sélectionner un label...",
                "subuser": "Sélectionner un sous-utilisateur...",
                "genre": "Sélectionner un genre...",
                "subgenre": "Sélectionner un sous-genre...",
                "ean": "Laisser vide si vous n'êtes pas sûr !",
                "release_description": "Quelques mots sur votre sortie. Pas de liens ni d'adresses e-mail, s'il vous plaît. 600 caractères max"
            },
            "help_text": {
                "name": "Veuillez ne pas utiliser d'ajouts au nom de la sortie tels que LP et EP.",
                "version": "Certaines sorties sont publiées en plus d'une version, si c'est le cas, veuillez entrer le nom de la version. Si votre sortie est originale/standard, veuillez ignorer ce champ.",
                "subuser": "Remarque : utilisez uniquement ce menu déroulant si vous souhaitez ajouter une sortie pour l'un de vos sous-utilisateurs, sinon laissez-le non sélectionné.",
                "label": "Remarque : veuillez sélectionner votre label <strong>{{labelName}}</strong> dans le menu déroulant s'il existe déjà dans le système, sinon créez votre label <strong>{{labelName}}</strong> en cliquant <5>ici</5>, une fois créé, vous pourrez le sélectionner dans le menu déroulant.",
                "catalog_number": "Insérez votre numéro de catalogue. Habituellement, les labels insèrent l'abréviation du nom du label et un numéro. Par exemple {{prefix}}001, {{prefix}}002...",
                "artwork": "Téléchargez des formats JPG, résolution uniquement 3000x3000 px, @ 72 dpi",
                "original_release_date": "Date de sortie originale pour tous les magasins dans le monde.",
                "official_release_date": "Date de sortie officielle pour tous les magasins dans le monde.",
                "release_language": "Dans quelle langue le nom de la sortie est-il écrit ? Veuillez vérifier à nouveau si vous n'êtes pas sûr. Si cette saisie est incorrecte, certains magasins comme iTunes et Apple Music rejetteront la sortie.",
                "ean": "Le code universel des produits ou le numéro d'article européen pour la sortie. Les codes valides sont de 13 chiffres. Si vous n'avez pas le vôtre, nous en générerons un pour vous."
            },
            "option": {
                "yes": "Oui",
                "no": "Non",
                "no_exclusive": "Pas d'exclusivité",
                "beatport_2weeks": "Beatport 2 semaines",
                "beatport_4weeks": "Beatport 4 semaines",
                "preorder_1week": "Pré-commande 1 semaine",
                "preorder_2weeks": "Pré-commande 2 semaines",
                "traxsource_2weeks": "Traxsource 2 semaines",
                "select": "Sélectionner...",
                "worldwide": "Mondial",
                "only_selected": "Seulement les pays sélectionnés",
                "all_except_selected": "Tous sauf les pays sélectionnés"
            },
            "message": {
                "track_name_required": "Veuillez taper le nom de la piste",
                "mix_name_required": "Veuillez taper le nom du mix",
                "mix_name_invalid": "Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores",
                "artist_required": "Veuillez sélectionner un artiste",
                "artist_type_required": "Veuillez sélectionner le type d'artiste",
                "catalog_duplicate": "Le numéro de catalogue '{{number}}' a été utilisé. Veuillez en insérer un autre.",
                "artist_added": "Nouvel artiste ajouté !",
                "track_limit": "Votre limite actuelle de pistes est de {{trackLimit}} piste(s). Pour télécharger plus de pistes, veuillez mettre à niveau votre compte ou contacter notre équipe de support.",
                "select_day": "Veuillez sélectionner un jour.",
                "form_error": "Le formulaire ne peut pas être soumis ! Veuillez remplir tous les champs et vérifier les erreurs !",
                "ean_invalid": "La valeur n'est pas un EAN valide. Si vous insérez une nouvelle sortie, laissez ce champ vide et nous générerons un EAN pour vous. Si vous téléchargez un catalogue précédent et que l'EAN n'est pas valide, veuillez nous contacter.",
                "ean_length": "Le numéro EAN doit être égal à 13 caractères",
                "artwork_invalid": "Ce fichier est invalide, veuillez vous assurer que l'image a une extension .jpg, des couleurs RGB, des dimensions de 3000 X 3000 et jusqu'à 4 Mo.",
                "track_invalid": "Ce fichier est invalide, veuillez vous assurer de bien encoder votre fichier en 16 bits, 44,1 Khz."
            },
            "button": {
                "reset": "Réinitialiser",
                "save_only": "Enregistrer seulement",
                "save_and_continue": "Enregistrer et continuer"
            },
            "modal": {
                "assisted_days": {
                    "header": "Êtes-vous sûr de vouloir ignorer les meilleures pratiques de date de sortie ?",
                    "body": "Veuillez noter qu'en sélectionnant cette option, votre date de sortie pourrait ne pas être acceptée par les magasins ou ingérée et publiée à la date sélectionnée. De plus, vous réduisez fortement les opportunités de marketing.",
                    "button": {
                        "cancel": "Annuler",
                        "confirm": "Confirmer"
                    }
                },
                "release_created": {
                    "header": "Sortie créée !",
                    "body": "Votre sortie a été créée avec succès !",
                    "button": {
                        "close": "Fermer"
                    }
                },
                "release_transfer_declaration": {
                    "header": "Déclaration de transfert de sortie",
                    "body": "J'ai vérifié et complété toutes les informations nécessaires pour cette sortie et elle est maintenant prête pour le TÉLÉCHARGEMENT.",
                    "button": {
                        "cancel": "Annuler",
                        "confirm": "Confirmer"
                    }
                }
            }
        }
    },
    "viewDetails": {
        "title": "Voir la sortie",
        "form": {
            "label": {
                "required": "Requis",
                "name": "Nom de la sortie",
                "version": "Version de la sortie",
                "subuser": "Sous-utilisateur",
                "label": "Label",
                "copyright": "Droits d'auteur ©",
                "copyright_year": "Année des droits d'auteur ©",
                "copyright_publisher": "Droits d'auteur ℗",
                "copyright_publisher_year": "Année des droits d'auteur ℗",
                "genre": "Genre",
                "subgenre": "Sous-genre",
                "catalog_number": "Numéro de catalogue",
                "artwork": "Illustration",
                "artwork_alt": "Votre illustration",
                "new_release": "Est-ce une nouvelle sortie ?",
                "original_release_date": "Date de sortie originale",
                "official_release_date": "Date de sortie officielle",
                "backcatalog": "Catalogue précédent",
                "assisted_dates": "Dates assistées",
                "exclusive_store_release_date": "Date de sortie exclusive en magasin",
                "additional_metadata": "Métadonnées supplémentaires",
                "release_description": "Description de la sortie",
                "release_language": "Langue du nom de la sortie",
                "auto_detect_language": "Détection automatique (Langue)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Génération automatique (ean)",
                "territories": "Territoires",
                "countries": "Pays",
                "youtube_declaration_header": "DÉCLARATION D'ID DE CONTENU YOUTUBE",
                "youtube_declaration_intro": "Pour opter pour l'ID de contenu YouTube pour cette sortie, vous devez vous assurer de remplir TOUTES les conditions suivantes :",
                "youtube_declaration_certify": "Je, <strong>{{firstName}} {{lastName}}</strong>, sous peine de parjure, certifie par la présente que les informations ci-dessus sont vraies et correctes.",
                "youtube_declaration_point1": "J'ai suffisamment de droits sur le matériel.",
                "youtube_declaration_point2": "Tout le contenu de référence est suffisamment distinctif.",
                "youtube_declaration_point3": "J'ai des références individuelles pour chaque œuvre de propriété intellectuelle.",
                "youtube_declaration_point4": "Le contenu livré n'est <strong>pas</strong> l'un des suivants : domaine public, contenu sous licence non exclusive, extraits d'autres sources utilisés sous les principes de l'utilisation équitable, séquences de jeu vidéo (par un autre que l'éditeur du jeu), enregistrements de karaoké, remasterisation sans autorisation, enregistrements similaires, contenu doublé, accélération/ralentissement, effets sonores, fonds sonores, mixes DJ continus, mashups, listes à rebours ou tout autre contenu interdit ou inéligible nommé dans les directives de l'ID de contenu YouTube ci-dessous.",
                "youtube_declaration_account": "Je comprends que mon compte peut être désactivé et résilié en cas de violations. De plus, je comprends pleinement que je peux être tenu responsable de tous frais, dommages, frais juridiques ou autres dépenses qui pourraient s'accumuler.",
                "youtube_declaration_guidelines": "Conformément aux <1><strong>Directives de l'ID de contenu YouTube</strong></1>, le contenu soumis par le biais de cette sortie est entièrement éligible pour l'ID de contenu YouTube.",
                "youtube_content_id_eligible": "Je confirme que mon contenu est éligible pour <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "Mon contenu n'est pas éligible pour <strong>Youtube Content ID</strong>",
                "immersive_audio": "Cette sortie a de l'audio immersif"
            },
            "placeholder": {
                "version": "Laisser vide si vous n'êtes pas sûr ou si c'est une sortie régulière",
                "select_date": "Sélectionner une date...",
                "copyright": "Habituellement le nom de votre label",
                "copyright_publisher": "Habituellement le nom de votre label",
                "copyright_year": "AAAA",
                "copyright_year_publisher": "AAAA",
                "catalog_number": "Insérez votre numéro de catalogue. Habituellement, les labels insèrent l'abréviation du nom du label et un numéro. Par exemple {{prefix}}001, {{prefix}}002...",
                "label": "Sélectionner un label...",
                "subuser": "Sélectionner un sous-utilisateur...",
                "artist": "Sélectionner un artiste...",
                "genre": "Sélectionner un genre...",
                "subgenre": "Sélectionner un sous-genre...",
                "ean": "Laisser vide si vous n'êtes pas sûr !",
                "release_description": "Quelques mots sur votre sortie. Pas de liens ni d'adresses e-mail, s'il vous plaît. 600 caractères max"
            },
            "help_text": {
                "name": "Veuillez ne pas utiliser d'ajouts au nom de la sortie tels que LP et EP.",
                "version": "Certaines sorties sont publiées en plus d'une version, si c'est le cas, veuillez entrer le nom de la version. Si votre sortie est originale/standard, veuillez ignorer ce champ.",
                "subuser": "Remarque : utilisez uniquement ce menu déroulant si vous souhaitez ajouter une sortie pour l'un de vos sous-utilisateurs, sinon laissez-le non sélectionné.",
                "catalog_number": "Insérez votre numéro de catalogue. Habituellement, les labels insèrent l'abréviation du nom du label et un numéro. Par exemple {{prefix}}001, {{prefix}}002...",
                "artwork": "Téléchargez des formats JPG, résolution uniquement 3000x3000 px, @ 72 dpi",
                "original_release_date": "Date de sortie originale pour tous les magasins dans le monde.",
                "official_release_date": "Date de sortie officielle pour tous les magasins dans le monde.",
                "release_language": "Dans quelle langue le nom de la sortie est-il écrit ? Veuillez vérifier à nouveau si vous n'êtes pas sûr. Si cette saisie est incorrecte, certains magasins comme iTunes et Apple Music rejetteront la sortie.",
                "ean": "Le code universel des produits ou le numéro d'article européen pour la sortie. Les codes valides sont de 13 chiffres. Si vous n'avez pas le vôtre, nous en générerons un pour vous."
            },
            "option": {
                "yes": "Oui",
                "no": "Non",
                "no_exclusive": "Pas d'exclusivité",
                "beatport_2weeks": "Beatport 2 semaines",
                "beatport_4weeks": "Beatport 4 semaines",
                "preorder_1week": "Pré-commande 1 semaine",
                "preorder_2weeks": "Pré-commande 2 semaines",
                "traxsource_2weeks": "Traxsource 2 semaines",
                "select": "Sélectionner...",
                "worldwide": "Mondial",
                "only_selected": "Seulement les pays sélectionnés",
                "all_except_selected": "Tous sauf les pays sélectionnés"
            },
            "message": {
                "track_name_required": "Veuillez taper le nom de la piste",
                "mix_name_required": "Veuillez taper le nom du mix",
                "mix_name_invalid": "Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores",
                "artist_required": "Veuillez sélectionner un artiste",
                "artist_type_required": "Veuillez sélectionner le type d'artiste",
                "catalog_duplicate": "Le numéro de catalogue '{{number}}' a été utilisé. Veuillez en insérer un autre.",
                "artist_added": "Nouvel artiste ajouté !",
                "track_limit": "Votre limite actuelle de pistes est de {{trackLimit}} piste(s). Pour télécharger plus de pistes, veuillez mettre à niveau votre compte ou contacter notre équipe de support.",
                "select_day": "Veuillez sélectionner un jour.",
                "form_error": "Le formulaire ne peut pas être soumis ! Veuillez remplir tous les champs et vérifier les erreurs !",
                "ean_invalid": "La valeur n'est pas un EAN valide. Si vous insérez une nouvelle sortie, laissez ce champ vide et nous générerons un EAN pour vous. Si vous téléchargez un catalogue précédent et que l'EAN n'est pas valide, veuillez nous contacter.",
                "ean_length": "Le numéro EAN doit être égal à 13 caractères",
                "artwork_invalid": "Ce fichier est invalide, veuillez vous assurer que l'image a une extension .jpg, des couleurs RGB, des dimensions de 3000 X 3000 et jusqu'à 4 Mo.",
                "track_invalid": "Ce fichier est invalide, veuillez vous assurer de bien encoder votre fichier en 16 bits, 44,1 Khz."
            },
            "button": {
                "submit": "Soumettre le formulaire"
            },
            "modal": {
                "assisted_days": {
                    "header": "Êtes-vous sûr de vouloir ignorer les meilleures pratiques de date de sortie ?",
                    "body": "Veuillez noter qu'en sélectionnant cette option, votre date de sortie pourrait ne pas être acceptée par les magasins ou ingérée et publiée à la date sélectionnée. De plus, vous réduisez fortement les opportunités de marketing.",
                    "button": {
                        "cancel": "Annuler",
                        "confirm": "Confirmer"
                    }
                },
                "release_updated": {
                    "header": "Sortie mise à jour !",
                    "body": "Votre sortie a été mise à jour avec succès !",
                    "button": {
                        "close": "Fermer"
                    }
                }
            }
        }
    },
    "artists_row": {
        "artistType": {
            "main": "Artiste principal",
            "featuring": "Artiste en featuring",
            "remixer": "Remixeur"
        },
        "placeholder": {
            "selectArtist": "Sélectionner un artiste..."
        },
        "button": {
            "remove": "Supprimer",
            "addAnother": "Ajouter un autre",
            "createNew": "Créer un nouveau ?"
        },
        "modal": {
            "header": "Êtes-vous sûr de vouloir attribuer cet artiste en tant qu'artiste en featuring ?",
            "body": "Veuillez ne pas confondre l'artiste en featuring avec un remixeur. L'artiste en featuring ne doit être ajouté que si vous êtes sûr et certain que cet artiste n'est pas l'artiste principal ou le remixeur.",
            "cancel": "Annuler",
            "confirm": "Confirmer"
        },
        "label": {
            "order": "Ordre",
            "artistName": "Nom de l'artiste",
            "artistType": "Type d'artiste",
            "artists": "Artistes",
            "required": "Requis"
        },
        "help_text": {
            "artists": "Si la sortie est écrite par plus de <strong>4 artistes principaux</strong>, veuillez utiliser <strong>Artistes divers</strong>. Les artistes des pistes, remixeurs et contributeurs doivent être ajoutés à l'étape d'édition des pistes."
        }
    },
    "tracks_row": {
        "label": {
            "tracks": "Pistes",
            "order": "Ordre",
            "trackName": "Nom de la piste",
            "mixName": "Nom du mix",
            "file": "Fichier",
            "albumOnly": "Seulement album",
            "required": "Requis",
            "stereo": "Stéréo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Ajouter un autre",
            "remove": "Supprimer ?",
            "onlyAlbum": "Seulement album",
            "mixTypes": {
                "originalMix": "Mix original",
                "remixOrMix": "Ceci est un remix ou un mix"
            }
        },
        "button": {
            "remove": "Supprimer",
            "addAnother": "Ajouter un autre"
        },
        "validation": {
            "trackName": "Veuillez taper le nom de la piste",
            "mixName": "Veuillez taper le nom du mix",
            "mixNameRegex": "Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores",
            "trackFile": "Veuillez sélectionner le fichier de la piste",
            "trackFileDolby": "Veuillez sélectionner le fichier dolby atmos de la piste",
            "trackFileDuration": "La durée des fichiers de piste stéréo et dolby doit correspondre",
            "swapTrackAudioTokenRequiredTooltip": "Votre solde actuel de tokens est insuffisant. Au moins 1 token est requis pour remplacer l'audio de la piste."
        }
    },
    "transfer_artists_row": {
        "label": {
            "artists": "Artistes",
            "order": "Ordre",
            "artistName": "Nom de l'artiste",
            "artistType": "Type d'artiste",
            "required": "Requis"
        },
        "placeholder": {
            "selectArtist": "Sélectionner un artiste..."
        },
        "help_text": {
            "artists": "Si la sortie est écrite par plus de <strong>4 artistes principaux</strong>, veuillez utiliser <strong>Artistes divers</strong>. Les artistes des pistes, remixeurs et contributeurs doivent être ajoutés à l'étape d'édition des pistes."
        },
        "option": {
            "artistType": {
                "main": "Artiste principal",
                "featuring": "Artiste en featuring",
                "remixer": "Remixeur"
            }
        },
        "button": {
            "remove": "Supprimer",
            "addAnother": "Ajouter un autre",
            "createNew": "Créer un nouveau ?"
        },
        "message": {
            "errorArtistRequired": "Veuillez sélectionner un artiste",
            "errorArtistTypeRequired": "Veuillez sélectionner le type d'artiste"
        },
        "modal": {
            "header": "Êtes-vous sûr de vouloir attribuer cet artiste en tant qu'artiste en featuring ?",
            "body": "Veuillez ne pas confondre l'artiste en featuring avec un remixeur. L'artiste en featuring ne doit être ajouté que si vous êtes sûr et certain que cet artiste n'est pas l'artiste principal ou le remixeur.",
            "button": {
                "cancel": "Annuler",
                "confirm": "Confirmer"
            }
        }
    },
    "store_picker": {
        "label": {
            "stores": "Boutiques"
        },
        "placeholder": {
            "search": "Rechercher une boutique..."
        },
        "section": {
            "mandatory": "Obligatoire",
            "optional": "Optionnel",
            "optional_locked": "Optionnel Boutiques Supplémentaires",
            "summary": {
                "read_only": "{{title}} ({{count}} au total)",
                "editable": "{{title}} ({{total}} au total, {{selected}} sélectionnés)"
            }
        },
        "message": {
            "no_stores": "Aucune boutique trouvée.",
            "availability": "Beatport est disponible uniquement pour les sorties Dance avec des labels approuvés par Beatport. Traxsource est disponible uniquement pour les sorties Dance avec des labels approuvés par Traxsource.",
            "youtube_declaration": "Veuillez d'abord signer la déclaration YouTube Content ID.",
            "youtube_ineligible": "Cette boutique n'est pas éligible car vous avez déclaré ne pas détenir les droits de propriété. En cas de fausse déclaration, vous pourriez être tenu responsable d'un litige.",
            "youtube_content_id": "Cette boutique n'est pas applicable aux sorties éligibles à YouTube Content ID car elle est livrée à la fois à YouTube Content ID et à YouTube Premium.",
            "beatport": "Beatport peut être sélectionné uniquement lorsque le genre est Dance et que le label est approuvé pour Beatport.",
            "traxsource": "Traxsource peut être sélectionné uniquement lorsque le genre est Dance et que le label est approuvé pour Traxsource.",
            "juno": "JunoDownload peut être sélectionné uniquement lorsque le genre est Dance.",
            "contact_support": "Veuillez contacter notre équipe support pour débloquer ces boutiques.",
            "optional_additional_none_selected": "Vous n'avez sélectionné aucune boutique supplémentaire optionnelle. Elles peuvent élargir votre portée. Êtes-vous sûr de vouloir les ignorer ?",
            "optional_paid_insufficient_tokens": "Solde de tokens insuffisant. Au moins 1 token est requis pour sélectionner des boutiques supplémentaires optionnelles.",
            "optional_paid_insufficient_tokens_with_link": "Votre solde actuel de tokens est insuffisant. Au moins 1 token est requis pour sélectionner des boutiques supplémentaires optionnelles. <2>Commander des tokens</2> pour continuer."
        }
    },
    "transfer_tracks_row": {
        "label": {
            "tracks": "Pistes",
            "order": "Ordre",
            "trackName": "Nom de la piste",
            "mixName": "Nom du mix",
            "file": "Fichier",
            "albumOnly": "Seulement album",
            "required": "Requis",
            "stereo": "Stéréo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Ajouter un autre",
            "remove": "Supprimer ?",
            "onlyAlbum": "Seulement album",
            "mixTypes": {
                "originalMix": "Mix original",
                "remixOrMix": "Ceci est un remix ou un mix"
            }
        },
        "button": {
            "remove": "Supprimer",
            "addAnother": "Ajouter un autre"
        },
        "validation": {
            "trackName": "Veuillez taper le nom de la piste",
            "mixName": "Veuillez taper le nom du mix",
            "mixNameRegex": "Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores",
            "trackFile": "Veuillez sélectionner le fichier de la piste",
            "trackFileDolby": "Veuillez sélectionner le fichier dolby atmos de la piste",
            "trackFileDuration": "La durée des fichiers de piste stéréo et dolby doit correspondre"
        }
    }
};

export default releasesFR;